import React from "react";

export type TPermission = {
  id: string;
  code: string;
  name: string;
  description: string;
};

export interface IPermissionsContextType {
  permissions: TPermission[];
  setPermissions: React.Dispatch<React.SetStateAction<TPermission[]>>;
  hasPermission: (permissionCode: string) => boolean;
  hasAnyPermission: (permissionCodes: string[]) => boolean;
  hasAllPermissions: (permissionCodes: string[]) => boolean;
  isLoading: boolean;
}

const PermissionsContext = React.createContext<IPermissionsContextType | undefined>(
  undefined
);

export default PermissionsContext;

